module.exports = __webpack_public_path__ + "img/kbeauty-1.95a09a56.svg";